export default __webpack_public_path__ + "static/media/REPORT_TRAINING.5858a1c4.svg";